import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class JwtInterceptorService implements HttpInterceptor {

    constructor(public apiService: ApiService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        const config = this.apiService.getConfig();
        const headers = {};
        let modified = false;
        if (config) {
            modified = true;
            headers['Authentication'] = `${config.token}`;
        }

        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (currentUser && currentUser.token) {
            modified = true;
            headers['Authorization'] = `Bearer ${currentUser.token}`;
        }

        if (modified) {
            request = request.clone({
                setHeaders: headers
            });
        }

        return next.handle(request);
    }
}
